module.exports = __webpack_public_path__ + "static/media/ils_esign_failed_myway.1194beea.svg";